import type { ServerRef } from '@bartizo/shared';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

/** Servers by name, each a link to its page; `count` says how many there are in all. */
export function ServerLinks({
  servers,
  count,
  to = (id: string) => `/servers/${encodeURIComponent(id)}`,
}: {
  servers: readonly ServerRef[];
  count?: number;
  to?: (id: string) => string;
}): ReactNode {
  const total = count ?? servers.length;
  return (
    <>
      {servers.map((server, i) => (
        <span key={server.id}>
          {i > 0 && ', '}
          <Link to={to(server.id)}>{server.name}</Link>
        </span>
      ))}
      {total > servers.length && ` and ${String(total - servers.length)} more`}
    </>
  );
}
